
    <cradua-approval-level
    [approvallevels]="approvallevels$ | async"
    (approvallevel)="onSubmitApprovalLevel($event)"
    (deleteApprovalLevelEvent)="onDeleteApprovalLevel($event)"
    *ngIf="(isLoading$ | async ) === false"
    >
  </cradua-approval-level>
  
    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoading$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  